var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFilterTagsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6864 1.91946C1.40315 1.54004 1.67392 1 2.14741 1H17.8279C18.3059 1 18.5754 1.54911 18.283 1.92723L12.5712 9.3136V14.2196C12.5712 14.4462 12.4382 14.6517 12.2314 14.7444L8.01721 16.636C7.63656 16.8069 7.20633 16.5284 7.20633 16.1112V9.3136L1.6864 1.91946Z",
    stroke: "#7D86A1",
    strokeWidth: 1.25
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterTagsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filterTagsIcon.937a35a1.svg";
export { ForwardRef as ReactComponent };